/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * @param {{ maxTps: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const near_chain_theor_tps_explanation = (params) => `NEAR theoretically can handle up to ${params.maxTps} TPS, and in a recent stress test on the testnet, it demonstrated the ability to manage 1,745 TPS (<a href='https://x.com/ekuzyakov/status/1832119511815737765' target='_blank' rel='noopener'>source</a>)`
